export default function () {

    const dealerCardToggles = document.querySelectorAll('.js-dealer-card-title');

    dealerCardToggles.forEach(function (dealerCardToggle, index) {
        dealerCardToggle.addEventListener("click", (e) => {
            dealerCardToggle.classList.toggle('is-active');
            dealerCardToggle.nextElementSibling.classList.toggle('is-active');
        });
    });

}
